export default {
  LOGS_LIST: "Logs list",
};
